// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3yh5T","paramInput":"JobSimulator_paramInput__3ImLr","input":"JobSimulator_input__3jvr0"};